interface LogoProps {
  className?: string;
}

export function GlobalGrowthLogo({ className = "w-full h-full" }: LogoProps) {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 50 50"
      className={className}
    >
      <path 
        fill="currentColor" 
        d="M30.7,17.2h7.5v28.2h-7.5s0-28.2,0-28.2ZM36.5,43.6v-24.7h-4.1v24.7h4.1Z" 
      />
      <path 
        fill="currentColor" 
        d="M19,45.3v-19.1h7.5v19.1s-7.5,0-7.5,0ZM24.9,43.6v-15.6h-4.1v15.7s4.1,0,4.1,0Z" 
      />
      <path 
        fill="currentColor" 
        d="M38.2,12.8v1.9h-7.6v-1.9h-4.4l8.1-8.1,8.2,8.1h-4.4ZM32.4,13h4.1v-2h1.9l-4-4-4,4h1.9v2Z" 
      />
      <path 
        fill="currentColor" 
        d="M14.9,45.4h-7.5v-10h7.5v10ZM9.1,43.6h4.1v-6.6h-4.1v6.6Z" 
      />
    </svg>
  );
}